// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DataTableWithForm_wrapper__42Atd","nameCell":"DataTableWithForm_nameCell__1Cv6I"};